var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready == 'idle')?_c('div',_vm._l((_vm.page.flexible_content),function(mod,key){return _c(("Flex" + (_vm.pascalize(mod.acf_fc_layout))),{key:key,tag:"component",attrs:{"data":mod}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }